import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  paidSubscriber: [],
  allPaidSubscriber: []
};

export const PaidSubscriberSlice = createSlice({
  name: "paidSubscriber",
  initialState,
  reducers: {
    getAllPaidSubscriberAction: (state, action) => {
      state.allPaidSubscriber = action.payload;
    },
  },
});

export default PaidSubscriberSlice.reducer;

export const { getAllPaidSubscriberAction } = PaidSubscriberSlice.actions;
